'use client'

import dynamic from 'next/dynamic'

import { RenderOnScroll } from '@/components/RenderOnScroll'

import type { TReviewsCarouselProps } from './ReviewsCarousel'

const DynamicReviewsCarousel = dynamic(() =>
	import('./ReviewsCarousel').then((mod) => mod.ReviewsCarousel),
)

export const LazyReviewsCarousel = (props: TReviewsCarouselProps) => (
	<RenderOnScroll element={<DynamicReviewsCarousel {...props} />} />
)
